import Vue from 'vue'
import BaseWorkspaceLayout from './BaseWorkspaceLayout'
import MobileSideBar from './MobileSideBar'

Vue.component('BaseWorkspaceLayout', BaseWorkspaceLayout)
Vue.component('MobileSideBar', MobileSideBar)
